import { React, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import OrderSampleList from './OrderSampleList';

const DashboardProspect = () => {
  const dataUser = useSelector((state) => state?.auth?.userDataDetail);
  const [tab, setTab] = useState('Campionature');
  const { t } = useTranslation();

  const Logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userDataDetail');
    localStorage.removeItem('agentDataDetail');
    window.location.href = '/';
  };

  useEffect(() => {
    document.getElementById('home_page_class').classList.remove('home_page');
  }, []);

  return (
    <>
      <div className="main_content order_page profile_page" style={{ paddingBottom: 100 }}>
        <div className="order_section_inner container">
          <div className="order_title">
            <h1>{t('Dashboard')}</h1>
            <button onClick={() => Logout()}>{t('Logout')}</button>
          </div>
          <div className="order_detail_card">
            <div className="title_section">
              {parseInt(dataUser?.parent_id) == 0 ? (
                <>
                  <h3>{t('Dati personali')}</h3>
                  <Link to={'/profile-manage/' + dataUser.id}>{t('Richiedi modifica')}</Link>
                </>
              ) : (
                <>
                  <h3>{t('Dati personali')}</h3>
                  <span style={{ fontSize: 14, color: '#8a8a8a' }}>{t('Contatta il tuo titolare per modificare i dati')}</span>
                </>
              )}
            </div>
            {parseInt(dataUser?.parent_id) == 0 ? (
              <div className="details_section">
                <div className="row_field details">
                  <div className="data">
                    <label>{t('Ragione sociale')}</label>
                    <strong>{dataUser?.business_name}</strong>
                  </div>
                  <div className="data">
                    <label>{t('P.IVA')}</label>
                    <strong>{dataUser?.vat_number}</strong>
                  </div>
                  <div className="data">
                    <label>{t('Email')}</label>
                    <strong>{dataUser?.email}</strong>
                  </div>
                  <div className="data">
                    <label>{t('Telefono')}</label>
                    <strong>{dataUser?.mobile_no}</strong>
                  </div>
                </div>
                <div className="row_field main_address">
                  <div className="data">
                    <label>{t('Indirizzo principale')}</label>
                    <strong>{dataUser?.address}</strong>
                  </div>
                </div>
                <div className="row_field sec_address">
                  <div className="data">
                    <label>{t('Indirizzi secondari')}</label>
                  </div>
                </div>
              </div>
            ) : (
              <div className="details_section">
                <div className="row_field details">
                  <div className="data">
                    <label>{t('Nome')}</label>
                    <strong>{dataUser?.fname} </strong>
                  </div>
                  <div className="data">
                    <label>{t('Cognome')}</label>
                    <strong>{dataUser?.lname}</strong>
                  </div>
                  <div className="data">
                    <label>Email</label>
                    <strong>{dataUser?.email}</strong>
                  </div>
                  <div className="data">
                    <label>{t('Telefono')}</label>
                    <strong>{dataUser?.phone}</strong>
                  </div>
                  <div className="data">
                    <label>{t('Ruolo')}</label>
                    <strong>{dataUser?.role}</strong>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="order_tab">
            <span 
              onClick={() => setTab('Campionature')} 
              className={`tab_title ${tab === 'Campionature' ? 'active' : ''}`}
            >
              {t('Campionature')}
            </span>
            <div className="tab_content order">
              <div className="content_info">
                <OrderSampleList />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardProspect;